<template>
  <div class="nav">
    <div class="nav_banner">
      <div class="nav_logo"></div>
      <div class="nav_carousel">
        <ul>
          <li
            v-for="(item, index) in nav"
            :key="index"
            @click="goAnchor('anchor' + index, index)"
            @mouseenter="togree(index)"
            @mouseleave="tonor(index)"
            :ref="index"
          >
            <keep-alive>
              <router-link
                :to="item.path == '' ? '' : item.path"
                :class="{ active: $store.state.s == index, active1: true }"
              >
                {{ item.name }}
              </router-link>
            </keep-alive>
            <!-- 软件产品 -->
            <!-- <div class="popupbox1" v-if="current == 1 && current == index">
              <div class="headline">
                <img
                  src="../../assets/img/xtpt@2x.png"
                  alt=""
                  align="AbsBottom"
                />
                系统平台
              </div>
              <div class="headline_box">
                <div>
                  <a href="javascript:;" class="bianse">市场运营管理平台</a>
                </div>
                <div>
                  <a href="javascript:;" class="bianse">商户进销存平台</a>
                </div>
                <div>
                  <a href="javascript:;" class="bianse">支付结算系统</a>
                </div>
                <div>
                  <a href="javascript:;" class="bianse">物联网平台</a>
                </div>
                <div>
                  <a href="javascript:;" class="bianse">电子会员系统</a>
                </div>
              </div>
              <div class="headline">
                <img
                  src="../../assets/img/ydyy@2x.png"
                  alt=""
                  align="AbsBottom"
                />移动应用
              </div>
              <div class="headline_box">
                <div>
                  <a href="javascript:;" class="bianse">市场营运管理APP</a>
                </div>
                <div>
                  <a href="javascript:;" class="bianse">商户进销存APP</a>
                </div>
                <div>
                  <a href="javascript:;" class="bianse">货主APP</a>
                </div>
                <div>
                  <a href="javascript:;" class="bianse">会员小程序</a>
                </div>
              </div>
            </div> -->

            <!-- 硬件产品 -->
            <!-- <div class="popupbox2" v-if="current == 2 && current == index">
              <div class="headline">
                <img
                  src="../../assets/img/sc@2x.png"
                  alt=""
                  align="AbsBottom"
                />
                市场智能硬件
              </div>
              <div class="headline_box1">
                <div>
                  <a href="javascript:;" class="bianse">智能PDA</a>
                </div>
                <div>
                  <a href="javascript:;" class="bianse">LED大数据屏</a>
                </div>
                <div>
                  <a href="javascript:;" class="bianse">信息查询触摸一体机</a>
                </div>
                <div>
                  <a href="javascript:;" class="bianse">智能水电表</a>
                </div>
                <div>
                  <a href="javascript:;" class="bianse">客流采集仪</a>
                </div>
                <div>
                  <a href="javascript:;" class="bianse">停车场管理</a>
                </div>
                <div>
                  <a href="javascript:;" class="bianse">食品安全检测设备</a>
                </div>
              </div>
              <div class="headline">
                <img
                  src="../../assets/img/sp@2x.png"
                  alt=""
                  align="AbsBottom"
                />
                商铺智能硬件
              </div>
              <div class="headline_box1">
                <div>
                  <a href="javascript:;" class="bianse">智能手持PDA</a>
                </div>
                <div>
                  <a href="javascript:;" class="bianse">语音播报打印机</a>
                </div>
                <div>
                  <a href="javascript:;" class="bianse">智能电子秤（台秤、桌秤）</a>
                </div>
                <div>
                  <a href="javascript:;" class="bianse">智能手持POS</a>
                </div>
              </div>
            </div> -->
            <!-- 解决方案 -->
            <!-- <div class="popupbox3"> -->
            <transition
              enter-active-class="animate__animated animate__fadeIn duration"
              leave-active-class="animate__animated animate__fadeOut duration"
            >
              <div class="popupbox3" v-show="current == 1 && current == index">
                <div
                  class="solution"
                  v-for="(item, index) in solution"
                  :key="item.path"
                  @mouseenter="moveIn(index)"
                  @mouseleave="moveOut(index)"
                  @click="goAnchor('anchor' + index, index)"
                  :class="{ moveClass: moveIndex == index || $route.path == item.path }"
                >
                  <keep-alive>
                    <router-link :to="item.path" class="solution_link">
                      <img
                        :src="$route.path == item.path || moveIndex == index ? item.select_img : item.img"
                        alt=""
                        align="AbsBottom"
                      />
                      {{ item.title }}
                    </router-link>
                  </keep-alive>
                </div>
              </div>
            </transition>
            <!-- <div class="popupbox3" v-if="current == 1 && current == index">
              <div class="headline">
                <img
                  src="../../assets/img/hy@2x.png"
                  alt=""
                  align="AbsBottom"
                />
                行业解决方案
              </div>
              <div class="headline_box">
                <div>
                  <router-link to="/solution/Wisdommarket" class="bianse"
                    >智慧农批</router-link
                  >
                </div>
                <div>
                  <router-link to="" class="bianse">智慧农贸</router-link>
                </div>
              </div>
              <div class="headline">
                <img
                  src="../../assets/img/ty@2x.png"
                  alt=""
                  align="AbsBottom"
                />
                通用解决方案
              </div>
              <div class="headline_box">
                <div>
                  <router-link to="/solution/Payplatform" class="bianse"
                    >支付结算平台</router-link
                  >
                </div>
                <div>
                  <router-link to="/solution/Loadometer" class="bianse"
                    >地磅无人值守</router-link
                  >
                </div>
              </div>
            </div> -->
          </li>
          <!-- <li><router-link to='/'>首页</router-link></li>
            <li>解决方案</li>
            <li>硬件设备</li>
            <li>客户案例</li>
            <li>合作伙伴</li>
            <li>关于我们</li>

             <router-link to='/index'>111111</router-link> -->
        </ul>
      </div>
      <div class="nav_login">
        <div class="iphone">
          <img src="../../assets/img/dianhua@2x.png" alt="" />
          <div class="iphone-title"></div>
          18106580695
        </div>
        <div class="right_login">
          <button>
            <a href="javascript:void(0);" @click="probation()">系统演示</a>
          </button>
          <!-- <button class="login"><a href="#">登录注册</a></button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //  nav: ["首页", "解决方案", "硬件设备", "客户案例", "合作伙伴", "关于我们"],
      nav: [
        {
          name: '首页',
          path: '/'
        },
        {
          name: '解决方案',
          path: ''
        },
        // {
        //   name: "智慧农批",
        //   path: "/SmartAgriculture",
        // },
        // {
        //   name: "智慧农贸",
        //   path: "/SmartTrade",
        // },
        // {
        //   name: "智慧园区",
        //   path: "/SmartPark",
        // },
        {
          name: '软件系统',
          path: '/systemPlatform'
        },
        {
          name: '智能硬件',
          path: '/hardwareProducts'
        },
        // {
        //   name: '产品定价',
        //   path: '/projectPrices'
        // },
        {
          name: '行业资讯',
          path: '/industryNews'
        },
        {
          name: '关于我们',
          path: '/AboutUs'
        }
      ],
      solution: [
        {
          title: '农产品产地市场',
          img: require('../../assets/img/SmartPark.png'),
          select_img: require('../../assets/img/SmartPark_1.png'),
          path: '/SmartPark'
        },
        {
          title: '农产品物流集散中心',
          img: require('../../assets/img/SmartAgriculture.png'),
          select_img: require('../../assets/img/SmartAgriculture_1.png'),
          path: '/SmartAgriculture'
        },
        {
          title: '农贸市场',
          img: require('../../assets/img/SmartTrade.png'),
          select_img: require('../../assets/img/SmartTrade_1.png'),
          path: '/SmartTrade'
        }
      ],
      current: -1,
      moveIndex: -1,
      n: ''
    }
  },
  created() {
    if (window.sessionStorage.getItem('store')) {
      this.$store.replaceState(
        Object.assign({}, this.$store.state, JSON.parse(window.sessionStorage.getItem('store')))
      )
    } else {
      this.$store.commit('Navigation', 0)
    }
    // if (this.$route.path == "/") {
    // }
  },
  watch:{
    '$route':{
      handler(newVal){
        this.nav.forEach((item,index)=>{
          if(item.path==newVal.path){
            this.$store.commit('Navigation', index)
          }
        })
      }
    }
  },
  beforeDestroy() {},
  methods: {
    //导航栏点击事件
    goAnchor(selector, index) {
      this.current = index
      this.$store.commit('Navigation', index)
    },
    //移入事件
    togree(index) {
      this.current = index
    },
    //移出事件
    tonor(index) {
      this.current = -1
    },
    moveIn(index) {
      this.moveIndex = index
    },
    moveOut(index) {
      this.moveIndex = -1
    },

    // 试用弹窗
    probation() {
      window.open('http://market.hopdata.vip/')
      // this.$store.commit('PageIds', true)
      // document
      //   .querySelector("body")
      //   .setAttribute("style", " overflow: hidden;");
      // this.ruleForm = {
      //   companyName: "",
      //   linkman: "",
      //   phone: "",
      //   messageCode: "",
      // };
      // clearInterval(this.timer);
      // this.timer = null;
    }
  }
}
</script>
<style scope>
@import url('./index.css');
</style>
